import { apiRequest } from '../utils/useAPIRequest';
import { businessStore, transactionStore } from '../stores';
import constant from '../utils/constant';
import moment from 'moment';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { queryClient } from '../App';

const transactions = async query => {
	if (!query) {
		// const startDate = moment().startOf('year');
		const startDate = moment('2022-01-01');
		const endDate = moment().endOf('month');
		query = `startDate=${startDate}&endDate=${endDate}&dateField=createdAt`;
	}
	const { status, data, errorMessage } = await apiRequest({
		url: `/transactions/transactions/business?${query}`,
		method: 'get',
	});

	if (status === constant.Success) {
		const wallet = [];
		const offline = [];

		transactionStore.setTransactions(data.transactions);

		data.transactions.forEach(trans => {
			if (trans.category === constant.CATEGORY.WALLET) {
				wallet.push(trans);
			}
			if (trans.category === constant.CATEGORY.OFFLINE) {
				offline.push(trans);
			}
		});
		transactionStore.setWalletTransactions(wallet);
		transactionStore.setOfflineTransactions(offline);

		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const getWalletTransactions = async query => {
	if (!query) {
		// const startDate = moment().startOf('year');
		const startDate = moment().startOf('month');
		const endDate = moment().endOf('month');
		query = `startDate=${startDate}&endDate=${endDate}&dateField=createdAt`;
	}
	const { status, data, errorMessage } = await apiRequest({
		url: `/transactions/transactions/business?category=WALLET&${query}`,
		method: 'get',
	});

	if (status === constant.Success) {
		const wallet = [];
		const offline = [];

		transactionStore.setTransactions(data.transactions);

		data.transactions.forEach(trans => {
			if (trans.category === constant.CATEGORY.WALLET) {
				wallet.push(trans);
			}
			if (trans.category === constant.CATEGORY.OFFLINE) {
				offline.push(trans);
			}
		});
		transactionStore.setWalletTransactions(wallet);
		transactionStore.setOfflineTransactions(offline);

		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const transactionById = async id =>
	await apiRequest({ url: `/transactions/${id}`, method: 'get' });

const transactionSummary = async query => {
	if (!query) {
		const startDate = moment('2022-01-01');
		const endDate = moment().endOf('month');
		query = `startDate=${startDate}&endDate=${endDate}&dateField=createdAt`;
	}
	const { status, data, errorMessage } = await apiRequest({
		url: `/transactions/new/transaction-summary?${query}`,
		method: 'get',
	});
	if (status === constant.Success) {
		transactionStore.setTransactionsSummary(data);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};


const tagIncome = async payload => {
	const transactionId =
		transactionStore.tag._id || transactionStore.untagged._id;
	const { status, errorMessage } = await apiRequest({
		url: `/transactions/taggedTransaction/${transactionId}`,
		method: 'put',
		payload,
	});
	if (status === constant.Success) {
		transactionStore.setTag({});

		queryClient.invalidateQueries({
			queryKey: [
				businessStore.bId,
				constant.apiQueryKey.Transactions.TransactionList,
			],
		});

		await Promise.all([transactionSummary()]);
		return { status: constant.Success };
	}
	return { errorMessage, status };
};


const useTransactionTypeList = (
	productTypeTableQuery,
	filterQuery,
	searchQuery
) => {
	const id = businessStore.bId;

	const query = useMemo(() => {
		if (searchQuery) {
			return `${productTypeTableQuery}&${filterQuery}&search=${searchQuery}`;
		} else if (filterQuery) {
			return `${productTypeTableQuery}&${filterQuery}`;
		} else {
			return productTypeTableQuery;
		}
	}, [filterQuery, productTypeTableQuery, searchQuery]);

	return useQuery({
		queryKey: [id, constant.apiQueryKey.Transactions.TransactionList, query],
		queryFn: () => {
			return apiRequest({
				url: `/transactions/transactions/business?${query}`,
				method: 'get',
			});
		},
		keepPreviousData: true,
	});
};

const TransactionsController = {
	transactions,
	transactionById,
	transactionSummary,
	tagIncome,
	useTransactionTypeList,
	getWalletTransactions,
};

export default TransactionsController;
